var MultiGeometryViewBase = require('../base/multi-geometry-view-base');
var PolylineView = require('./polyline-view');

var MultiPolygonView = MultiGeometryViewBase.extend({
  GeometryViewClass: PolylineView
});

module.exports = MultiPolygonView;



//////////////////
// WEBPACK FOOTER
// ./~/cartodb.js/src/geo/geometry-views/leaflet/multi-polyline-view.js
// module id = 1543
// module chunks = 6